import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Anchor, Chip, ListItemLayout, randomColours, SkillLevel, SkillPercentage } from '@keplerco/core';
import classNames from 'classnames';
import styles from './skill-list-item.module.css';
import { RequiredDesignationDto, SearchSkillDto } from '../../../apis';
import { PagePath } from '../../../navigation/navigation.enums';

export function SkillListItem(skill: SearchSkillDto): JSX.Element {
  const [requiredDesignations, setRequiredDesignations] = useState<Array<RequiredDesignationDto | undefined>>([]);
  useEffect(() => {
    const designations = skill.requiredRoles?.flatMap(x => x.requiredDesignations);
    if (designations != undefined) {
      setRequiredDesignations(designations)
    }
  }, []);
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 768;
  return (
    <ListItemLayout>
      <div
        onClick={() => navigate(PagePath.skill.replace(":skillId", skill.skillId!))}
        className={classNames('card', [styles.itemContainer])}>
        <div className={classNames([styles.content])}
          style={{ gridTemplateColumns: (isMobile ? '1fr' : 'minmax(0px, 1fr) 180px'), paddingBottom: 20 }}>
          <div>
            <div className={classNames('heading5', [styles.heading])}>{skill.name}</div>
            <p className={classNames('caption1', styles.skillCardText)}>{skill.description}</p>
          </div>
          <div className={styles.actions}>
            <div className={styles.info}>
              <React.Fragment>
                <div className={styles.scores}>
                  {
                    skill.ovarallScore != undefined ? (
                      <SkillPercentage
                        percentage={skill.ovarallScore ?? 0}
                        notAssessed={!skill.ovarallScore}
                        title="Overall Quiz Score"
                      />
                    ) : (
                      <Chip label="Not Assessed" variant="tiny" backgroundColour={'default'} colour="white" ></Chip>)
                  }
                </div>
              </React.Fragment>
            </div>
          </div>
        </div>
        <div className={classNames([styles.content])}
          style={{ gridTemplateColumns: (isMobile ? '1fr' : 'minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr)'), paddingBottom: 20 }}>
          {
            skill.categories != undefined &&
            skill.categories?.length > 0 &&
            skill.categories
              .map((x, i) => {
                return <Chip label={x} variant="tiny" backgroundColour={randomColours[i + 1]} colour="white" ></Chip>
              }
              )}
        </div>

        {
          skill.requiredRoles != undefined &&
          skill.requiredRoles?.length > 0 && <>
            {
              skill.requiredRoles.map(z => {
                return <div >
                  <p className={classNames('caption1')}>{z.roleName}: </p>
                  <div className={styles.info} style={{ gridTemplateColumns: (isMobile ? '1fr' : 'minmax(0px, 1fr) 180px'), paddingBottom: 20 }}>
                    <React.Fragment>
                      <div className={styles.scores}>

                        {z.requiredDesignations?.map((x, i) => {
                          return <>
                            <SkillLevel
                              level={x?.level ?? 0}
                              minLevel={0}
                              maxLevel={6}
                              notAssessed={false}
                              title={`(${x.level}) ${x?.roleDesignationName}`}
                            />
                          </>
                        })}
                      </div>
                    </React.Fragment>
                  </div>
                </div>
              })}
          </>
        }
        <div className={classNames([styles.itemAnchor])}>
          <Anchor
            onClick={() => navigate(PagePath.skill.replace(":skillId", skill.skillId!))}>
            View Topics
          </Anchor>
        </div>
      </div>
    </ListItemLayout>
  );
}
